// Persistent auth token storage for auto-login
// Uses localStorage which persists across app restarts in both web browsers and Capacitor WebViews

const TOKEN_KEY = 'nidoux_remember_token';

export const saveRememberToken = (token) => {
  try {
    localStorage.setItem(TOKEN_KEY, token);
  } catch (err) {
    console.error('Failed to save remember token:', err);
  }
};

export const getRememberToken = () => {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch (err) {
    console.error('Failed to get remember token:', err);
    return null;
  }
};

export const clearRememberToken = () => {
  try {
    localStorage.removeItem(TOKEN_KEY);
  } catch (err) {
    console.error('Failed to clear remember token:', err);
  }
};
